export const LIST_EMPTY_ADD = 'list-empty-add';
export const LIST_EMPTY_SEARCH = 'list-empty-search';
export const LIST_EMPTY_APPROVALS = 'list-empty-approvals';

export const ERROR = 'error';

export const XERO = 'integration-logo--xero';
export const QBO = 'integration-logo--qbo';
